import React from "react";
import PropTypes from "prop-types";
import { Label, Select, PlaceholderOption } from "./styles";

export const UIComponent = ({ label, name, data, style, styleLabel, space, ...otherProps }) => {
  const renderSpace = () => {
    if (style && space) {
      return { ...style, marginTop: 16 };
    } else if (space) {
      return { marginTop: 16 };
    } else if (style) {
      return style;
    }
  };

  return (
    <>
      <Label title={label} style={styleLabel}>
        {label}
        <Select name={name} id={name} style={renderSpace()} {...otherProps}>
          <PlaceholderOption value="">Presiona para seleccionar</PlaceholderOption>
          {data.map(({ id, name: nameData }) => (
            <option value={id} key={id}>
              {nameData}
            </option>
          ))}
        </Select>
      </Label>
    </>
  );
};

UIComponent.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  style: PropTypes.object,
  styleLabel: PropTypes.object,
  space: PropTypes.bool,
};
